// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__7LaVk","sublink":"breadcrumbs_sublink__UK0d_","link":"breadcrumbs_link__3LJHN","pageHistory":"breadcrumbs_pageHistory__CuWtH"};